import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';
// Locals
import ar from 'vuetify/src/locale/ar';
import en from 'vuetify/src/locale/en';

import {
  VApp,
  VMain,
  VContainer,
  VBreadcrumbs,
  VBreadcrumbsItem,
  VBtn,
  VTextField,
  VAutocomplete,
  VSheet,
  VSlideGroup,
  VSlideItem,
  VRow,
  VCol,
  VCard,
  VImg,
  VSpacer,
  VIcon,
  VInput,
  VMenu,
  VSwitch,
  VDatePicker,
  VSimpleTable,
  VBanner,
} from 'vuetify/lib/components';

Vue.use(Vuetify, {
  components: {
    VApp,
    VMain,
    VContainer,
    VBreadcrumbs,
    VBreadcrumbsItem,
    VBtn,
    VTextField,
    VAutocomplete,
    VSheet,
    VSlideGroup,
    VSlideItem,
    VRow,
    VCol,
    VCard,
    VImg,
    VSpacer,
    VIcon,
    VInput,
    VMenu,
    VSwitch,
    VDatePicker,
    VSimpleTable,
    VBanner,
  },
});

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ar, en },
    current: 'ar',
  },
  theme: {
    themes: {
      light: {
        primary: '#158E8D',
        secondary: '#e0cf97',
      },
    },
  },
});
